import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import MaterialTable from 'material-table';
import Modal from '@material-ui/core/Modal';
import DataList from '../../../Analytics/components/DataList';

const styles = theme => ({
  preview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
  },
  favesBarGraph: {
    backgroundColor: 'red',
    width: '1%',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  tableContainer: {
    maxWidth: 1000,
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
});

class TeamsAnalyticsList extends React.Component {
  constructor(props) {
    super(props);

    const { classes } = props;
    this.columns = [
      {
        title: 'Team/Player',
        field: 'name',
        render: rowData => {
          const name = rowData.name ? rowData.name : 'Anonymous user';
          const logo = rowData.logo && rowData.logo.url ? rowData.logo.url : '';

          return (
            <div className={classes.displayName}>
              <Avatar className={classes.avatar} src={logo}>
                <PersonOutlineOutlinedIcon />
              </Avatar>
              {name}
            </div>
          );
        },
        cellStyle: { width: '15%' },
      },
      { title: 'League', field: 'league', cellStyle: { width: '15%' } },
      {
        title: '# Times Favorited',
        field: 'total',
        cellStyle: { width: '10%' },
      },
      {
        title: '',
        field: 'percentage',
        render: rowData => {
          const percentage = rowData.percentage ? rowData.percentage : 0;
          return (
            <div className={classes.favesBarGraph} style={{ width: percentage + '%' }} />
          );
        },
        width: '70%',
      },
    ];
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <MaterialTable
          elevation={0}
          // key={pageSize}
          options={{
            // pageSize: pageSize,
            // filtering: true,
            toolbar: true,
            paging: true,
            exportButton: true,
            exportAllData: true,
          }}
          columns={this.columns}
          data={this.props.teamsAnalyticsList}
          title="Faves"
          onRowClick={(event, rowData) => {
            if (rowData && rowData.users) {
              this.props.openUserList(rowData.users);
            }
          }}
        />
        {this.props.showUsersFaves && (
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.props.showUsersFaves}
            onClose={() => this.props.setShowUsersFaves(false)}
            className={classes.preview}
          >
            <div className={classes.containerUsersAnalyticsView}>
              <div style={{ textAlign: 'center' }}>
                <DataList listUsersInteraction={this.props.listUsersInteraction} />
              </div>
            </div>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(TeamsAnalyticsList);
